import React, { useEffect, useState } from "react";
import { FiClock, FiX } from "react-icons/fi";
import { isServerClockReady, serverNow } from "../utils/serverClock";
import "./device-clock-notice.css";

export default function DeviceClockNotice() {
  const [wrong, setWrong] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    const check = () => setWrong(isServerClockReady() && Math.abs(Date.now() - serverNow()) > 300000);
    check();
    const timer = window.setInterval(check, 15000);
    return () => window.clearInterval(timer);
  }, []);
  if (!wrong || dismissed) return null;
  return <aside className="device-clock-notice" role="status" dir="rtl">
    <FiClock aria-hidden="true" />
    <span>ساعت دستگاه با سرور هماهنگ نیست. زمان‌بندی برنامه بر اساس ساعت سرور است؛ لطفاً تنظیم خودکار تاریخ و ساعت دستگاه را روشن کنید.</span>
    <button type="button" aria-label="بستن هشدار ساعت دستگاه" onClick={() => setDismissed(true)}><FiX /></button>
  </aside>;
}
